import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, Form } from 'redux-form/immutable';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

import { showDialog, hideDialog } from '../../../redux/actions/dialogs';
import { email, required, phoneNumber } from '../../../utils/formvalidation';
import { renderPermissions, renderTags, renderTextField } from '../../../utils/reduxforms';
import { name } from '../../../utils/helper';
import Gravatar from '../../Common/Gravatar';
import ReduxDialog from '../../Common/ReduxDialog';
import { saveEmployeeFormHandler } from '../../../redux/routines';

import styles from './styles';
import { getDialogContextValue } from '../../../redux/selectors';
import { EMPLOYEE_DIALOG } from '../../../redux/constants/dialogs';
import { toJS } from '../../../utils/helper';

class EmployeeDialog extends Component {
  state = {};

  render() {
    const { handleSubmit, initialValues, submit, hideDialog } = this.props;

    const employee = initialValues.toJS();
    console.log('employee', employee);

    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={() => hideDialog(EMPLOYEE_DIALOG)}
      >Cancel</Button>,
      <Button
        key="save"
        variant="contained"
        color="primary"
        onClick={() => submit()}
      >Save</Button>,
    ];

    return (
      <ReduxDialog
        title={employee && employee.id ? name(employee) : 'Add Employee'}
        actions={actions}
        modal={false}
        name={EMPLOYEE_DIALOG}
        autoScrollBodyContent
        bodyStyle={styles.body}
        fullWidth
        maxWidth="sm"
      >
        <Form onSubmit={handleSubmit(saveEmployeeFormHandler)}>
          <Grid container spacing={8}>
            {employee && employee.email ? <Grid item>
              <Gravatar
                email={employee.email}
                size={280}
              />
            </Grid> : null}
            <Grid item xs>
              <Grid container style={styles.main} spacing={8}>
                <Grid item xs={6}>
                  <Field
                    name="firstName"
                    component={renderTextField}
                    label="First Name"
                    fullWidth
                    validate={required}
                    disabled={employee && employee.shared}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    name="lastName"
                    component={renderTextField}
                    label="Last Name"
                    fullWidth
                    validate={required}
                    disabled={employee && employee.shared}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    name="mobile"
                    component={renderTextField}
                    label="Mobile"
                    fullWidth
                    validate={[required, phoneNumber]}
                    disabled={employee && employee.shared}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    name="email"
                    component={renderTextField}
                    label="Email"
                    fullWidth
                    validate={[required, email]}
                    disabled={employee && employee.shared}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    name="permissions"
                    component={renderPermissions}
                    label="Permissions"
                    fullWidth
                    validate={required}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    name="tags"
                    component={renderTags}
                    label="Tags"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      </ReduxDialog>
    );
  }
}

EmployeeDialog.propTypes = {
  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

const form = reduxForm({
  form: EMPLOYEE_DIALOG,  // a unique identifier for this form
  // onSubmit: (values, dispatch, props) => {
  //   return dispatch(saveEmployeeRoutine.trigger(values));
  // },
  onSubmitSuccess: (result, dispatch, props) => {
    console.log('onSubmitSuccess');
    props.hideDialog(EMPLOYEE_DIALOG);
  },
  onSubmitFail: (errors) => {
    console.error(errors);
  }
})(EmployeeDialog);

function mapStateToProps(state) {
  return {
    employees: toJS(state.getIn(['employees', 'employees'])),
    initialValues: getDialogContextValue(state)(EMPLOYEE_DIALOG, 'employee'),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Employees/EmployeeDialog/index.js